<template>
  <div>
    <ui-top-app-bar
      id="top-app-bar"
      v-bind:short="true"
      v-bind:shortCollapsed="this.appBarCollapsed"
      navId="nav-menu"
      contentSelector="#content-main">
      Skyline
    </ui-top-app-bar>

    <ui-drawer type="modal" v-model="appBarMenuOpen" menuSelector="#nav-menu">
      <ui-drawer-header>
        <ui-drawer-title>Skyline</ui-drawer-title>
        <ui-drawer-subtitle>A Looking Glass For Earth</ui-drawer-subtitle>
      </ui-drawer-header>
      <ui-drawer-content>
        <ui-list>
          <ui-list-divider/>
          <ui-list-group-subheader>Pages</ui-list-group-subheader>
          <ui-item v-bind:activated="isRoute('/landing')" @click="openRoute('/landing')">
            <ui-item-first-content>
              <ui-icon>phone_android</ui-icon>
            </ui-item-first-content>
            <ui-item-text-content>Skyline App</ui-item-text-content>
          </ui-item>

          <ui-item v-bind:activated="isRoute('/presents')" @click="openRoute('/presents')" >
            <ui-item-first-content>
              <ui-icon>photo_album</ui-icon>
            </ui-item-first-content>
            <ui-item-text-content>Presents Gallery</ui-item-text-content>
          </ui-item>

          <ui-item  v-bind:activated="isRoute('/changelog')" @click="openRoute('/changelog')" >
            <ui-item-first-content>
              <ui-icon>line_weight</ui-icon>
            </ui-item-first-content>
            <ui-item-text-content>Changelog</ui-item-text-content>
          </ui-item>

          <ui-item  v-bind:activated="isRoute('/privacy')" @click="openRoute('/privacy')" >
            <ui-item-first-content>
              <ui-icon>visibility_off</ui-icon>
            </ui-item-first-content>
            <ui-item-text-content>Privacy Policy</ui-item-text-content>
          </ui-item>

          <ui-list-group-subheader>External Links</ui-list-group-subheader>

          <ui-item v-bind:activated="false">
            <ui-item-first-content>
              <ui-icon>translate</ui-icon>
            </ui-item-first-content>
            <ui-item-text-content>Translate (WIP)</ui-item-text-content>
          </ui-item>

          <ui-item v-bind:activated="false" @click="openExternal('https://fincher.im')" >
            <ui-item-first-content>
              <ui-icon>face</ui-icon>
            </ui-item-first-content>
            <ui-item-text-content>Author</ui-item-text-content>
          </ui-item>
        </ui-list>
        <ui-list-divider/>
        <ui-item @click="appBarMenuOpen = false">
          <ui-item-first-content>
            <ui-icon>arrow_back</ui-icon>
          </ui-item-first-content>
          <ui-item-text-content>Close</ui-item-text-content>
        </ui-item>
      </ui-drawer-content>
    </ui-drawer>

    <ui-drawer-backdrop/>

    <main>
      <div id="content-main">
        <ui-grid class="skyline-main-grid" style="max-width: 1280px;">
          <ui-grid-cell class="skyline-cell" :columns="{default:1, tablet:1, phone:0}"/>
          <ui-grid-cell class="skyline-cell" :columns="{default:10, tablet:6, phone:4}" id="skyline-main-grid-page-container-cell">
            <transition name="component-fade" mode="out-in">
              <router-view/>
            </transition>
          </ui-grid-cell>
          <ui-grid-cell class="skyline-cell" :columns="{default:1, tablet:1, phone:0}"/>
        </ui-grid>

        <ui-grid class="skyline-footer-grid" style="max-width: 1280px;">
          <ui-grid-cell class="skyline-cell" :columns="{default:1, tablet:1, phone:0}"/>
          <ui-grid-cell class="skyline-cell" :columns="{default:10, tablet:6, phone:4}">
            <span :class="$tt('overline')" style="color: gray;">BY <a href="https://fingame.works" target="_blank">
              FINGAMEWORKS</a> © 2017 - {{ new Date().getFullYear() }}<br>
              <a href="https://fincher.im" target="_blank">
              JUSTIN FINCHER</a> PRESENTS
            </span>
          </ui-grid-cell>
          <ui-grid-cell class="skyline-cell" :columns="{default:1, tablet:1, phone:0}"/>
        </ui-grid>
      </div>
    </main>
  </div>
</template>

<style>
  @import "../styles/main.css";
  .component-fade-enter-active, .component-fade-leave-active {
    transition: opacity .3s ease;
  }
  .component-fade-enter, .component-fade-leave-to
    /* .component-fade-leave-active for below version 2.1.8 */ {
    opacity: 0;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity 1.5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  #landing_title_app_name
  {
    background:transparent url(../../public/img/app_icon@256.png) no-repeat;
    background-position: 0 center;
  }

  /* Extra small devices (phones, 600px and down) */
  @media only screen and (max-width: 600px) {
    #landing_title_app_name
    {
      background-size: 2.8rem 2.8rem;
      padding: 0 0 0.4rem 3.6rem;
    }
  }

  /* Small devices (portrait tablets and large phones, 600px and up) */
  @media only screen and (min-width: 600px) {
    #landing_title_app_name
    {
      background-size: 3.6rem 3.6rem;
      padding: 0 0 0.5rem 4.5rem;
    }
  }

  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) {
    #landing_title_app_name
    {
      background-size: 3.6rem 3.6rem;
      padding: 0 0 0.5rem 4.5rem;
    }
  }

  /* Large devices (laptops/desktops, 992px and up) */
  @media only screen and (min-width: 992px) {
    #landing_title_app_name
    {
      background-size: 5rem 5rem;
      padding: 0 0 0.7rem 6rem;
    }
  }

  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1200px) {
    #landing_title_app_name
    {
      background-size: 6rem 6rem;
      padding: 0 0 0.7rem 7rem;
    }
  }
</style>
<script>
import $ from 'jquery'
window.jQuery = $
export default
{
  name: 'app',
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods:
    {
      openRoute: function (path) {
        if (!this.isRoute(path)) {
          this.$router.push(path)
        }
      },
      openExternal: function (path) {
        const win = window.open(path, '_blank')
        win.focus()
      },
      isRoute: function (path) {
        return this.$router.currentRoute.fullPath === path
      },
      handleScroll: function (event) {
        this.appBarCollapsed = (document.documentElement.scrollTop <= 10 * parseInt(getComputedStyle(document.documentElement).fontSize))
      },
      selectTopMenu: function (item) {
        this.$router.push({ path: item.item.getAttribute('route').substr(1) })
      }
    },
  components:
      {
      },
  data () {
    return {
      appBarMenuOpen: false,
      appBarCollapsed: true
    }
  }
}
</script>
